/** @format */

"use client";

/** @format */

import { useEffect } from "react";
import { getFormattedPrice, getVendorSettings } from "../../../services/helper";
import ItemAddonView from "../ItemAddonView";
import Barcode from "react-barcode";

const POSInvoice = () => {
  const latestOrder = JSON.parse(localStorage.getItem("latestOrder"));

  const vendor_email = getVendorSettings("email");
  const vendor_store_name = getVendorSettings("name");
  const vendor_address = getVendorSettings("vendor_contact_address");
  const vendor_phone = getVendorSettings("vendor_contact_phone");

  const {
    showStoreName,
    showStorePhone,
    showStoreAddress,
    showStoreEmail,
    showStoreLogo,
    headerNote,
    footerNote,
  } = getVendorSettings("receiptTemplate");

  useEffect(() => {
    if (latestOrder) {
      // Trigger print after the page has fully loaded
      setTimeout(() => {
        window.print();
      }, 500); // Add a small delay to ensure content is rendered
    }
  }, [latestOrder]);

  if (!latestOrder) {
    return <p>No order found</p>;
  }

  const {
    id: txnID,
    items,
    sale_amount,
    discount,
    tax,
    paid,
    customer_paid,
    tax_apply,
    redeem_points_value,
  } = latestOrder;

  const subtotal = items.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString();
  const formattedTime = currentDate.toLocaleTimeString();

  const changeDue = Math.max(0, parseFloat(paid) - parseFloat(sale_amount));

  return (
    <div
      style={{
        fontFamily: "monospace",
        padding: "10px",
        maxWidth: "350px",
        margin: "0 auto",
        backgroundColor: "#f9f9f9",
        fontSize: "12px",
      }}
    >
      {/* Barcode at top */}
      {showStoreLogo && (
        <div className="d-flex justify-content-center">
          <Barcode
            displayValue={false}
            height={50}
            value={`tealbo`}
            style={{ fill: "transparent" }}
          />
        </div>
      )}
      <div style={{ textAlign: "center", margin: "10px 0" }}>
        {showStoreLogo && (
          <div style={{ fontSize: "40px", letterSpacing: "2px" }}>Tealbo</div>
        )}
      </div>
      {/* Store Header */}
      <div style={{ textAlign: "center", marginBottom: "5px" }}>
        {showStoreName && (
          <div style={{ fontWeight: "bold", fontSize: "14px" }}>
            {vendor_store_name}
          </div>
        )}
        {showStoreAddress && (
          <div style={{ fontSize: "11px" }}>{vendor_address}</div>
        )}
        {showStorePhone && (
          <div style={{ fontSize: "11px" }}>Tel: {vendor_phone}</div>
        )}
        {showStoreEmail && (
          <div style={{ fontSize: "11px" }}>{vendor_email}</div>
        )}
        {headerNote && (
          <div style={{ marginBottom: "10px", marginTop: "10px " }}>
            {headerNote}
          </div>
        )}
      </div>
      {/* Transaction Info */}
      <div style={{ marginBottom: "10px" }}>
        <div>
          Date: {formattedDate} {formattedTime}
        </div>
        <div>Trans: Sales Transaction</div>
        <div>Trans#: {txnID}</div>
        {/* <div>Opr.: {vendor_store_name.substring(0, 2)}</div> */}
      </div>
      {/* Items Section */}
      <div style={{ marginBottom: "10px" }}>
        {items.map((item, index) => {
          const addons =
            typeof item.addons === "string"
              ? JSON.parse(item.addons)
              : item.addons;

          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: "8px",
              }}
            >
              {/* Left Side: Quantity, Name, Addons */}
              <div style={{ width: "70%" }}>
                <div style={{ display: "flex", gap: "8px", fontWeight: 500 }}>
                  <span>{item.quantity}x</span>
                  <span
                    style={{
                      flex: 1,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.id}-{item.name}
                  </span>
                </div>

                {/* ✅ Addons view */}
                {addons && Object.keys(addons).length > 0 && (
                  <div
                    style={{
                      marginTop: "2px",
                      paddingLeft: "20px",
                      fontSize: "0.85em",
                      color: "#777",
                    }}
                  >
                    <ItemAddonView addons={addons} />
                  </div>
                )}
              </div>

              {/* Right Side: Total Price */}
              <div
                style={{
                  minWidth: "80px",
                  textAlign: "right",
                  fontWeight: 500,
                }}
              >
                {getFormattedPrice(item.quantity * item.price)}
              </div>
            </div>
          );
        })}
      </div>
      {/* Divider */}
      <div
        style={{
          borderBottom: "1px dashed #000",
          marginBottom: "10px",
        }}
      ></div>
      {/* Totals Section */}
      <div style={{ marginBottom: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <span>Subtotal:</span>
          <span>{getFormattedPrice(subtotal)}</span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <span>Discount:</span>
          <span>{getFormattedPrice(discount)}</span>
        </div>

        {tax_apply && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <span>Tax:</span>
            <span>{getFormattedPrice(tax)}</span>
          </div>
        )}

        {/* Divider */}
        <div
          style={{
            borderBottom: "1px dashed #000",
            marginBottom: "10px",
          }}
        ></div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
            marginBottom: "5px",
          }}
        >
          <span>Total:</span>
          <span>{getFormattedPrice(sale_amount)}</span>
        </div>

        {/* Divider */}
        <div
          style={{
            borderBottom: "1px dashed #000",
            marginBottom: "10px",
          }}
        ></div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <span>Amount Paid:</span>
          <span>{getFormattedPrice(paid)}</span>
        </div>
        
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <span>Change Given:</span>
          <span>{getFormattedPrice(changeDue)}</span>
        </div>
        
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <span>Balance Due:</span>
          <span>
            {(() => {
              const balance = parseFloat(sale_amount) - parseFloat(paid);
              return balance > 0 ? getFormattedPrice(balance) : '$0.00';
            })()}
          </span>
        </div>
      </div>
      {/* Rewards Points */}
      {redeem_points_value > 0 && (
        <div style={{ marginBottom: "10px" }}>
          <div>{vendor_store_name} Rewards</div>
          <div>Points Received: {Math.floor(paid)}</div>
          <div>
            Redeem Points Value: {getFormattedPrice(redeem_points_value)}
          </div>
        </div>
      )}
      {/* Footer */}
      <div style={{ marginTop: "10px" }}>
        {footerNote && <div>{footerNote}</div>}
      </div>
      {/* Coupon Section (if applicable) */}
      <div style={{ marginBottom: "10px" }}>
        <div>Coupon Generated</div>
        <div>
          Coupon Amount: {getFormattedPrice(discount > 0 ? discount : 0)}
        </div>
      </div>
      {/* Bottom Barcode */}
      <div className="d-flex justify-content-center">
        <Barcode
          displayValue={false}
          height={50}
          value={`tealbo`}
          style={{ fill: "transparent" }}
        />
      </div>
      {/* Footer */}
    </div>
  );
};

export default POSInvoice;
